import { CommonModule } from '@angular/common';
import { Component, HostListener, OnDestroy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService, SSOService } from '../../../services';
import { BaseButtonComponent } from '../../button/button.component';

@Component({
  selector: 'app-inactive-popup',
  templateUrl: './inactive-popup.component.html',
  styleUrls: ['./inactive-popup.component.scss'],
  standalone: true,
  imports: [CommonModule, BaseButtonComponent, TranslateModule],
})
export class InactivePopup implements OnDestroy {
  constructor(private authService: AuthService) {}

  @HostListener('window:beforeunload')
  handleBeforeUnload() {
    this.ngOnDestroy();
  }

  ngOnDestroy(): void {
    localStorage.clear();
    sessionStorage.clear();
    document.cookie = '__cfduid=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  logout(): void {
    this.authService.logout();
    window.location.href = '/login';
  }
}
